<template>
  <div
    class="GoogleMap"
    ref="googleMap"
    :id="id"
    :style="`height:${height}px;width:${width}px;`"
    :heatmapData="heatmap"
  ></div>
</template>

<script>
import { getMapOptions } from './options';

export default {
  name: 'GoogleMap',
  data() {
    return {
      center: null,
      map: null,
      heatmap: [],
    };
  },
  methods: {
    createCenter() {
      // eslint-disable-next-line no-undef
      this.center = new google.maps.LatLng(
        this.mapCenter.latitude,
        this.mapCenter.longitude
      );
    },
    initMap() {
      this.createCenter();
      const options = getMapOptions({
        zoom: 1,
        center: this.center,
      });
      // eslint-disable-next-line no-undef
      this.map = new google.maps.Map(this.$refs.googleMap, options);
    },
    createHeatMap() {
      this.heatmap = new google.maps.visualization.HeatmapLayer({
        data: this.heatmapData,
      });
      this.heatmap.setMap(this.map);
    },
  },
  mounted() {
    setTimeout(() => {
      this.initMap();
      this.createHeatMap();
    }, 100);
  },
  watch: {
    heatMap(newValue, previusValue) {
      if (previusValue === newValue)
        return this.initMap() && this.createHeatMap();
    },
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      required: false,
      default: 1000,
    },
    zoom: {
      type: Number,
      required: false,
      default: 1,
    },
    width: {
      type: Number,
      required: false,
      default: 600,
    },
    mapCenter: {
      type: Object,
      required: true,
      validator(value) {
        return (
          value.hasOwnProperty('latitude') && value.hasOwnProperty('longitude')
        );
      },
    },
    heatmapData: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.GoogleMap {
  border: rem(1px) solid $white-700;
}
</style>
